import { render } from "./Resources.vue?vue&type=template&id=3b2a0b60"
import script from "./Resources.vue?vue&type=script&lang=js"
export * from "./Resources.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/villageOverview/Resources.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b2a0b60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b2a0b60', __exports__)) {
    api.reload('3b2a0b60', __exports__)
  }
  
  module.hot.accept("./Resources.vue?vue&type=template&id=3b2a0b60", () => {
    api.rerender('3b2a0b60', render)
  })

}


export default __exports__